import { useRouter } from 'next/router'

import styled from 'styled-components'

import { device } from '@/common/constants/device'

import Text from '@/components/common/Text'
import Button from '@/components/ui/Button'
import { HOME_PAGE } from '@/common/constants/analytics'
import { userAmplitudeAnalytics } from '@/common/services/userAmplitudeAnalytics'
import { useTranslations } from 'next-intl'

const Wrap = styled.section`
  background: url('/_next_static/landing/exclusives/bg-s.webp') center
      bottom/contain no-repeat,
    #f5f5f5;
  border-radius: 24px;
  padding: 1rem;
  padding-bottom: 19.125rem;

  @media ${device.tablet} {
    padding: 2.5rem;
    padding-bottom: 28.1875rem;
    background: url('/_next_static/landing/exclusives/bg-t.webp') center
        bottom/540px 465px no-repeat,
      #f5f5f5;
  }

  @media ${device.laptop} {
    padding-bottom: 16.75rem;
    background: url('/_next_static/landing/exclusives/bg-l.webp') right
        bottom/450px 450px no-repeat,
      #f5f5f5;
  }

  @media ${device.laptopL} {
    padding: 6.25rem 6.875rem 5.625rem 6.875rem;
    background: url('/_next_static/landing/exclusives/bg-ll.webp') 700px
        bottom/560px 580px no-repeat,
      #f5f5f5;
  }
`

const Title = styled.h2`
  max-width: 775px;
  margin-bottom: 0.5rem;
  font-weight: 800;
  font-size: 1.5em;
  line-height: 1.125;
  letter-spacing: -0.02em;

  @media ${device.tablet} {
    margin-bottom: 1.25rem;
    font-size: 2.5em;
  }

  @media ${device.laptopL} {
    width: 500px;
  }
`

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
  max-width: 530px;

  @media ${device.tablet} {
    margin-top: 2rem;
    margin-bottom: 3rem;
  }
`

const Item = styled.li`
  width: 50%;
  margin-top: 0.75rem;
`

const CustomText = styled(Text)`
  margin-bottom: 0.25rem;
`

const Btn = styled(Button)`
  padding: 1rem 2rem;
`

const Exclusives = () => {
  const router = useRouter()
  const t = useTranslations('index')

  const onButtonClick = () => {
    userAmplitudeAnalytics.trackEvent(`${HOME_PAGE}_page_reg_cta_clicked`)
    router.push('/register')
  }

  return (
    <Wrap id="exclusives">
      <Title>{t('seaOfExclusive')}</Title>
      <List>
        <Item>
          <CustomText color="black" size="24" sizeT="32" weight="700">
            1B+
          </CustomText>
          <Text size="12" sizeT="18" weight="500">
            {t('creativesAvailable')}
          </Text>
        </Item>
        <Item>
          <CustomText color="black" size="24" sizeT="32" weight="700">
            2.5B+
          </CustomText>
          <Text size="12" sizeT="18" weight="500">
            {t('appCreatives')}
          </Text>
        </Item>
        <Item>
          <CustomText color="black" size="24" sizeT="32" weight="700">
            57M+
          </CustomText>
          <Text size="12" sizeT="18" weight="500">
            {t('mediaFiles')}
          </Text>
        </Item>
        <Item>
          <CustomText color="black" size="24" sizeT="32" weight="700">
            354K+
          </CustomText>
          <Text size="12" sizeT="18" weight="500">
            {t('uniqueApplications')}
          </Text>
        </Item>
      </List>
      <Btn filled size="14" sizeT="18" onClick={onButtonClick}>
        {t('registration')}
      </Btn>
    </Wrap>
  )
}

export default Exclusives
